export default __webpack_public_path__ + "static/media/users.4eb7cf25.svg";